'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'

import { PLACE_AUTOCOMPLETE_STALE_MS } from '@/lib/locations/place-autocomplete-query'

function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  })
}

/**
 * Root TanStack Query provider (platform shell, public pages, location autocomplete, etc.).
 */
export function AppQueryProvider({ children }: { children: React.ReactNode }) {
  const [client] = useState(() => createAppQueryClient())

  return <QueryClientProvider data-component-id="src/components/providers/AppQueryProvider.tsx:26:9" data-component-path="src/components/providers/AppQueryProvider.tsx" data-component-line="26" data-component-end-line="26" data-component-file="AppQueryProvider.tsx" data-component-name="QueryClientProvider" data-component-content="%7B%22elementName%22%3A%22QueryClientProvider%22%7D" client={client}>{children}</QueryClientProvider>
}

export { PLACE_AUTOCOMPLETE_STALE_MS }
